// extracted by mini-css-extract-plugin
module.exports = {"component":"teaser-grid_component__1_f7R","rowWrapper":"teaser-grid_rowWrapper__dLQdq","headline":"teaser-grid_headline__RfAPU"};